import $ from "jquery";


class MenuController {
  constructor() {
    this.toPacksButton = document.getElementsByClassName('close-menu');
    this.menuOverlay = document.getElementById('menu-principal');
    this.theMenuIcon = document.getElementsByClassName('open-main-menu');
    this.theMenuIconMobile = document.getElementsByClassName('sticky-navbar__burger-menu-icon');
    this.events();
  }

  events() {

    $(document).ready(function () {
      if (window.location.hash.length > 1) {
        $('html, body').animate({
          scrollTop: $(window.location.hash).offset().top
        });
      }
    });

    for (let i = 0; i < this.theMenuIcon.length; i++) {
      this.theMenuIcon[i].addEventListener('click', this.openMenu.bind(this));
    }

    for (let i = 0; i < this.theMenuIconMobile.length; i++) {
      this.theMenuIconMobile[i].addEventListener('click', this.openMenu.bind(this));
    }

    for (let i = 0; i < this.toPacksButton.length; i++) {
      this.toPacksButton[i].addEventListener('click', this.closeMenu.bind(this));
      this.toPacksButton[i].addEventListener('click', this.goToHash.bind(this));
    }

    document.querySelector('.sticky-navbar__cross-menu-icon').addEventListener('click', this.closeMenu.bind(this));
  }

  goToHash() {
    console.log("clicked");
  }

  openMenu() {
    document.body.classList.add('no-scroll');
    document.documentElement.classList.add('no-scroll');
    this.menuOverlay.classList.add("menu-principal--active");
  }

  closeMenu() {
    this.menuOverlay.classList.remove("menu-principal--active");
    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('no-scroll');
  }
}


export default MenuController;
